import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeTable,
  mapDdeTable,
  type ServerDdeTableResponse,
} from './ddeTableTypes';

type GetDdeTablesRequest = {
  page: number;
  size: number;
};

type ServerGetDdeTablesResponse = {
  items?: ServerDdeTableResponse[] | null;
  page: number;
  pages?: number;
  size: number;
  total: number;
};

export type DdeTablesPage = {
  items: DdeTable[];
  page: number;
  pages?: number;
  size: number;
  total: number;
};

export const getDdeTables = async ({
  page,
  size,
}: GetDdeTablesRequest): Promise<DdeTablesPage> => {
  const response = await sylvanus.get<ServerGetDdeTablesResponse>(
    '/dde/tables',
    {
      params: { page, size },
    },
  );

  return {
    items: (response.items ?? []).map(mapDdeTable),
    page: response.page,
    pages: response.pages,
    size: response.size,
    total: response.total,
  };
};
